<template>
	<Col :span="24">
		<VerticalLayout>
			<MasonryContainer>
				<MasonryItem headerKey="settings.vrsSettingsForm.brdcmHeader">
					<BrdcmSettingsForm :loading="isLoading" :settings="settings" />
				</MasonryItem>
			</MasonryContainer>
			<RouteLeaveModal
				:visible="modalVisible"
				:confirm="modalOk"
				:cancel="modalCancel"
			/>
		</VerticalLayout>
	</Col>
</template>

<script lang="ts">
import { onMounted, ref } from 'vue';
import { Col } from 'ant-design-vue';

import Api from '@/api/Api';
import { toCamelCase } from '@/api/ApiHelpers';

import RouteLeaveModal from '@/components/common/RouteLeaveModal.vue';
import { useRouteLeaveModal } from '@/components/common/useRouteLeaveModal';
import VerticalLayout from '@/components/common/VerticalLayout.vue';
import MasonryContainer from '@/components/masonry/MasonryContainer.vue';
import MasonryItem from '@/components/masonry/MasonryItem.vue';
import BrdcmSettingsForm from '@/components/settings/BrdcmSettingsForm.vue';
import type { BrdcmSettingsProp } from '@/components/settings/brdcmSettingsFormUtils';
import { useProvideInjectFormChangedStatuses } from '@/utils/useProvideInject';


type VrsSettingsGetResponse = {
	settings: Record<string, unknown>;
};

export default {
	components: {
		Col,
		VerticalLayout,
		MasonryContainer,
		MasonryItem,
		BrdcmSettingsForm,
		RouteLeaveModal,
	},
	setup() {
		const isLoading = ref(true);
		const settings = ref<BrdcmSettingsProp>({});
		const {
			formChangedStatuses,
			modalVisible,
			modalOk,
			modalCancel,
		} = useRouteLeaveModal();
		const { provideValue } = useProvideInjectFormChangedStatuses;
		provideValue(formChangedStatuses);

		const fetchSettings = () => {
			isLoading.value = true;
			Api.vrsSettingsGet((responseData: VrsSettingsGetResponse) => {
				settings.value = toCamelCase(responseData.settings);
				isLoading.value = false;
			});
		};
		onMounted(fetchSettings);

		return {
			isLoading,
			settings,
			modalVisible,
			modalOk,
			modalCancel,
		};
	},
};
</script>
